/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if(pollConnection === 1) { poll_connection.onready(); }
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();
		specific_overlaymenu.onready();
		specific_workshopfilter.onready();
		specific_artworkfilter.onready();

		/*
		Popups
		*/
		$(document).on('click','.js-column',function() {

			var _url = $(this).data('url');

			/*
			Popup: Open
			*/
			popup.open(1,1,_url);

		});

		/*
		Be My Guest
		*/
		$(document).on('click','.js-choose-option',function() {
			
			/*
			Unselect
			*/
			$('.js-choose-option').removeClass('active');

			/*
			Select
			*/
			$(this).addClass('active');

			/*
			Title
			*/
			var _title = $(this).data('title');
			$('.js-choose-title').text(_title);

			$('.js-form-input-option').val(_title);

		});

		/*
		Columns Hover
		*/
		// $(".js-column").on({
		//     mouseenter: function () {

		//     $('.js-column').removeClass('hover');

		//     $(this).addClass('hover');
		      
		//     $('.js-column').map(function() {

		//     	if(
		//     		$(this).hasClass('hover')
		//     	) {

		//     		$(this).find('.background').stop().animate({
		// 				'height':'105%'
		// 			},100);
		    	
		//     	} else {

		//     		$(this).find('.background').stop().animate({
		// 				'height':'100%'
		// 			},100);

		//     	}

		//     });

		//     },
		//     mouseleave: function () {
		      
		//       	$(this).find('.background').stop().animate({
		// 			'height':'100%'
		// 		},100);

		//     }
		// });

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 